<kpa-loader></kpa-loader>
<div>
	<div
		kendoTypography
		variant="h4"
		class="title">
		Announcements
	</div>
	<div
		id="announcements-content"
		class="kendo-announcements-content">
		<kpa-announcements-card
			[isDashboard]="false"
			[announcements]="announcements"></kpa-announcements-card>
	</div>
</div>
